import queryString from 'query-string';

const parse = (rawUrl) => {
  const { url, query = Object.create(null) } = queryString.parseUrl(rawUrl);

  return { url, query };
};

export const setThumborSignedURL = (rawUrl) => {
  const parsed = parse(rawUrl);
  const { url } = parsed;
  let { query } = parsed;

  query = Object.assign(query, {
    singOnThumbor: true
  });

  const signedUrl = `${url}?${queryString.stringify(query)}`;

  return signedUrl;
};

export const unsetThumborSignedURL = (rawUrl) => {
  const parsed = parse(rawUrl);
  const { url } = parsed;
  let { query } = parsed;

  query = Object.assign(query, {
    singOnThumbor: void 0
  });

  const signedUrl = `${url}?${queryString.stringify(query)}`;

  return signedUrl;
};
